<template>
  <div class="custom-order">
    <Breadcrumb></Breadcrumb>

    <!-- 过滤条件 -->
    <div class="form-body">
      <el-form :model="form" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="店铺名称：" class="item">
                <div
                  style="max-height: 200px;overflow-y: auto; float: left;
                    width: calc(100% - 59px);"
                >
                  <el-input
                    v-if="isExpand"
                    style="width: 139px; margin: 0 29px 0 0"
                    v-model="shopName"
                    size="small"
                    placeholder="店铺名称"
                  ></el-input>
                  <el-checkbox @change="handleChangeShop" v-model="isCheckShop"
                    >全选</el-checkbox
                  >
                  <el-checkbox-group
                    filterable
                    v-model="form.shopId"
                    placeholder="请选择店铺名称"
                    class="input"
                    size="small"
                    clearable
                    style="display: inline; margin: 0 0 0 27px"
                  >
                    <el-checkbox
                      v-for="(item, index) in shopList"
                      :key="index"
                      :label="item.shopId"
                      v-show="isExpand || index < 10"
                    >
                      {{ item.shopName
                      }}<span v-if="item.amazonSite"
                        >({{ dictMap["amazon_site"][item.amazonSite] }})</span
                      >
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div
                  v-if="shopList.length > 10"
                  @click="isExpand = !isExpand"
                  style="margin: 0 0 0 16px; cursor: pointer; color: #4934b2;float:left;"
                >
                  {{ isExpand ? "－收起" : "＋展开" }}
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="平台渠道：" class="item">
                <el-select
                  clearable
                  v-model="form.platNo"
                  placeholder="请选择平台渠道"
                  class="input"
                  size="small"
                >
                  <el-option
                    v-for="(value, index) in dictData['plat_no']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="8">
            <el-form-item label="订单编号：" class="item">
              <el-input
                v-model="form.appNo"
                class="input"
                size="small"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div class="item right">
              <el-button type="primary" size="small" @click="getData(1)"
                >搜索</el-button
              >
              <el-button type="default" size="small" @click="reset"
                >重置</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table-body">
      <div class="top">
        <div class="left"></div>
        <div class="right">
          <pagination
            :total="total"
            :page.sync="form.pageNum"
            :limit.sync="form.pageSize"
            @pagination="getData"
          />
        </div>
      </div>
      <el-table
        id="myOrder"
        ref="table"
        :data="tableData"
        class="table"
        :default-expand-all="true"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
              ref="detailTable"
              class="table"
              border
              :data="[props.row]"
              :show-header="false"
            >
              <el-table-column width="400">
                <template slot-scope="scope">
                  <div class="table-info-wrap">
                    <div
                      class="table-info"
                      v-for="(item, index) in scope.row.skuList"
                      :key="index"
                    >
                      <div class="left">
                        <img
                          class="mini-img"
                          :src="item.amazonPicUrl ? item.amazonPicUrl : noImage"
                          slot="reference"
                        />
                      </div>
                      <div class="right">
                        <div
                          :title="item.amazonProductName"
                          class="text-ellipsis"
                        >
                          {{ item.amazonProductName }}
                        </div>
                        <div :title="item.color" class="text-ellipsis">
                          {{ item.color }}
                        </div>
                        <div :title="item.size" class="text-ellipsis">
                          {{ item.size }}
                        </div>
                        <div :title="item.itemSku" class="text-ellipsis">
                          {{ item.itemSku }}
                        </div>
                        <div
                          v-if="false"
                          :title="`${item.proName}(${item.designId})`"
                          class="text-ellipsis"
                        >
                          {{ item.proName }}({{ item.designId }})
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center">
                <template>
                  <div class="loan-wrap">
                    待编辑
                    <br />
                    【未关联】
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="600">
                <template slot-scope="scope">
                  <div class="table-info-wrap">
                    <div
                      class="table-info1"
                      v-for="(item, index) in scope.row.skuList"
                      :key="index"
                    >
                      <div style="overflow: hidden" class="left">
                        <img
                          style="float: left"
                          class="mini-img"
                          :src="item.picUrl ? item.picUrl : noImage"
                          slot="reference"
                        />
                        <div
                          style="
                            float: left;
                            margin: 0 0 0 8px;
                            width: calc(100% - 112px);
                          "
                        >
                          <div
                            @click="handleJumpProduct(item.designId)"
                            style="color: #4934b2; cursor: pointer"
                          >
                            {{ item.proName }}
                          </div>
                          <div v-if="item.designId">
                            成品编号： {{ item.designId }}
                          </div>
                          <div>
                            <span v-if="item.properName && item.properVal">
                              <span
                                v-for="(i, ind) in [0, 1]"
                                :key="'i_' + ind"
                                style="margin-right: 10px"
                              >
                                {{ item.properName.split(":")[i] }}：
                                {{ item.properVal.split(":")[i] }}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        style="float: right; width: 200px; text-align: center"
                      >
                        <div v-if="!item.skuId">
                          <div style="color: red; margin: 0 0 8px 0">
                            需关联产品
                          </div>
                          <div>
                            <el-button
                              type="primary"
                              size="small"
                              @click="relate(item)"
                              >关联产品</el-button
                            >
                          </div>
                        </div>
                        <div v-else>
                          <span style="color: green"> 无需关联 </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="平台产品" align="center" width="360">
          <template slot-scope="scope">
            <div style="text-align: left">订单号：{{ scope.row.appNo }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="订单状态/匹配类型"
          align="center"
        ></el-table-column>
        <el-table-column label="定制产品" align="center" width="400">
          <template slot-scope="scope">
            <div v-if="scope.row.platNo">
              {{ dictMap["plat_no"][scope.row.platNo] || "" }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="getData"
      />
    </div>

    <!-- 关联订单弹窗 -->
    <RelateOrder
      :visible="showEdit"
      :order="currentOrder"
      @onClose="hideEdit"
      @update="handleUpdate"
    />
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import RelateOrder from "./components/RelateOrder"
import { mapGetters } from "vuex"
import { orderList } from "@/api/order/all"
import { getShopList } from "@/api/system/shopManage"
import noImage from "@/assets/images/no_image.png"

export default {
  name: "toMatchOrder",
  components: {
    Breadcrumb,
    RelateOrder,
  },
  data() {
    return {
      form: {
        platNo: "", // 平台渠道
        shopId: [], // 店铺名称
        appNo: this.$route.query.appNo || "", // 订单编号
        ansi: "",
        pageNum: 1,
        pageSize: 100,
        orderStatus: "09",
      },
      total: 0,
      tableData: [], // 表格数据
      showEdit: false,
      currentOrder: {},
      currentOrderSku: {
        attribute: "",
      },
      shopList: [],
      noImage: noImage,
      isCheckShop: true,
      isExpand: false,
      shopName: "",
      isExpand: false,
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  mounted() {
    this.getData()
    this.getShops()
  },
  methods: {
    getShops() {
      getShopList().then((res) => {
        this.shopList = res.rows
        // this.handleChangeShop()
        // res.rows.map(()=>{})
      })
    },
    handleChangeShop() {
      this.form.shopId = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.form.shopId.push(record.shopId)
        })
      }
    },
    // 搜索
    getData() {
      let params = Object.assign({}, this.form)
      params.shopIds = params.shopId.join(",")
      delete params["shopId"]

      orderList(params).then((res) => {
        if (res.code !== 200) {
          this.$message.error("获取订单列表失败")
        } else {
          this.total = res.total
          this.tableData = res.rows
        }
      })
    },
    handleJumpProduct(designId) {
      let routeUrl = this.$router.resolve({
        path: "/select/custom/product",
        query: { designId: designId },
      })
      window.open(routeUrl.href, "_blank")
    },
    // 重置
    reset() {
      this.form = {
        platNo: "", // 平台渠道
        shopId: [], // 店铺名称
        appNo: "", // 订单编号
        ansi: "",
        pageNum: 1,
        pageSize: 100,
        orderStatus: "09",
      }
    },
    relate(data) {
      this.currentOrder = data
      this.showEdit = true
    },
    hideEdit() {
      this.showEdit = false
      this.getData()
    },
    okEditSale() {
      this.getData()
      this.showEditSale = false
    },
    handleUpdate() {
      this.showEdit = false
      let appNo = this.$route.query.appNo
      let platNo = this.$route.query.platNo
      if (appNo) {
        if (platNo == "03") {
          this.$router.push({
            path: "/order/myOrder/orderLazada",
          })
        }
        if (platNo == "05") {
          this.$router.push({
            path: "/order/myOrder/orderShopee",
          })
        }
        if (platNo == "10") {
          this.$router.push({
            path: "/order/myOrder/orderTiktok",
          })
        }
      } else {
        this.getData()
      }
    },
  },
}
</script>

<style scoped>
.form-body {
  padding: 10px 20px;
}

.form-body .item {
}
.form-body .item.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-body {
  margin-top: 10px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 12px;
  overflow: hidden;
}

.table-body /deep/.el-table .cell {
  padding: 0;
}

.table-body .top {
  padding: 0 0 8px 0;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding-right: 0;
}

.table-body > .table {
  margin-bottom: 10px;
}

.table-info-wrap {
  margin-bottom: -10px;
}

.table-info {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px;
}

.table-info1 {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px;
  justify-content: space-between;
}

.table-info:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

.table-info .left {
  margin-right: 12px;
  height: 97px;
  margin-bottom: 10px;
  float: left;
}

.table-info .left .mini-img {
  width: 95px;
  height: 95px;
}

.table-info .right {
  font-size: 12px;
  width: 270px;
  padding: 0 0 4px 0;
}

.table-info1:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

.table-info1 .left {
  margin-right: 12px;
  height: 97px;
  margin-bottom: 10px;
  float: left;
}

.table-info1 .left .mini-img {
  width: 95px;
  height: 95px;
}

.table-info1 .right {
  font-size: 12px;
  width: 200px;
  padding: 0 0 4px 0;
}

.loan-wrap {
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;
  text-align: center;
}

.loan-wrap .title.lw40 {
  width: 24px;
}

.loan-wrap .title {
  width: 48px;
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
}

.operate {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.operate .link {
  font-size: 12px;
  color: #4934b2;
  cursor: pointer;
}

.table /deep/.el-table_1_column_1 {
  width: 0px !important;
  height: 0px !important;
}

.table /deep/.el-table_1_column_1 .cell {
  visibility: hidden !important;
  cursor: not-allowed !important;
}

.table /deep/.el-table__expanded-cell[class*="cell"] {
  padding: 8px 16px;
}
.table-body /deep/ .expanded {
  background: #f5f7fa;
}
</style>
